const PREFIX = 'highlights';

export const getSpartanProductFeatureShowcaseTracking = (prefix: string) => ({
  section: prefix,
  header: `${prefix}-header`,
  eyebrow: `${prefix}-eyebrow`,
  title: `${prefix}-title`,
  description: `${prefix}-description`,
  featureList: `${prefix}-feature-list`,
  feature: (index: number) => `${prefix}-feature-${index + 1}`,
  featureToggle: (index: number) => `${prefix}-feature-${index + 1}-toggle`,
  featureTitle: (index: number) => `${prefix}-feature-${index + 1}-title`,
  featureDescription: (index: number) =>
    `${prefix}-feature-${index + 1}-description`,
  featureImage: (index: number) => `${prefix}-feature-${index + 1}-image`,
  featureContent: (index: number) => `${prefix}-feature-${index + 1}-content`,
  desktopImageWrap: `${prefix}-desktop-image-wrap`,
  desktopImage: (index: number) => `${prefix}-desktop-image-${index + 1}`,
  remark: `${prefix}-remark`,
});

export const SPARTAN_PRODUCT_FEATURE_SHOWCASE_TRACKING =
  getSpartanProductFeatureShowcaseTracking(PREFIX);

export const getSpartanProductFeatureShowcaseDataGA = (prefix: string) => ({
  section: prefix,
});

export const SPARTAN_PRODUCT_FEATURE_SHOWCASE_DATA_GA =
  getSpartanProductFeatureShowcaseDataGA(PREFIX);
